import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classNames from 'classnames';

import { SUCCESS } from 'features/order-tracker/pages/AmendAppointmentPage/components/Notification/constants';
import { LivePersonChat, StatusInfo } from 'features/order-tracker/shared-components';
import { CHAT_BUTTON_PURPLE } from 'features/order-tracker/shared-components/LivePersonChat/constants';
import { openOTPopUp, setNotificationType } from 'features/order-tracker/store/actions';
import { useLivePersonPageChange } from 'features/order-tracker/store/hooks/useLivePersonPageChange';
import { getOrderStatusLivePersonProps } from 'features/order-tracker/store/selectors';
import { toggleMainWindowScroll } from 'features/order-tracker/utils';

import { MAP_CONTENT_BY_STEP } from './constants';

import styles from './styles.module.scss';

export const TodaysEngineerAppointmentInfo: React.FC<components.TodaysEngineerAppointmentInfo> = ({
  step,
  setNextStep,
}) => {
  const dispatch = useDispatch();
  const livePersonDivId = useSelector(getOrderStatusLivePersonProps);
  const { title, status, statusText, messages, actionSteps } = MAP_CONTENT_BY_STEP[step];

  useEffect(() => useLivePersonPageChange(), [step]);

  const openOTPopUpHandler = (): void => {
    toggleMainWindowScroll();
    setTimeout(() => dispatch(openOTPopUp()), 0);
  };

  return (
    <>
      <div className={styles.titleContainer}>
        <h3>{title}</h3>
        <StatusInfo status={status} statusText={statusText} />
      </div>
      <div className={styles.topMessage}>{messages[0]}</div>
      {!!messages[1] && <div>{messages[1]}</div>}
      {!!actionSteps && (
        <div className={styles.actionButtonContainer}>
          {actionSteps.map(
            ({
              type,
              nextStep,
              label,
              analytics,
              disabled,
              hasSuccessBanner,
              isChatButton,
              isTrackAnotherOrderButton,
            }) =>
              isChatButton ? (
                <LivePersonChat
                  key={livePersonDivId}
                  livePersonId={livePersonDivId}
                  chatType={CHAT_BUTTON_PURPLE}
                  analytics={analytics}
                  altLabel={label}
                />
              ) : (
                <button
                  key={type}
                  type="button"
                  data-analytics-link={analytics}
                  onClick={() => {
                    if (isTrackAnotherOrderButton) {
                      openOTPopUpHandler();
                    } else {
                      setNextStep && setNextStep(nextStep);
                      hasSuccessBanner && dispatch(setNotificationType(SUCCESS));
                    }
                  }}
                  className={classNames(styles.actionButton, styles[type], { [styles.disabled]: disabled })}
                  disabled={disabled}
                >
                  {label}
                </button>
              ),
          )}
        </div>
      )}
    </>
  );
};
